// extracted by mini-css-extract-plugin
export default {"container":"tile_container__vQKK9","label":"tile_label__lZNaH","value":"tile_value__XfPQB"};